import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "64",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"64\" height=\"64\" fill=\"rgb(var(--situational-lightgrey))\" rx=\"32\"></rect><path fill=\"url(#a)\" d=\"M32.088 20.588c2.026-3.242 11.274-8.703 17.896 1.364 6.615 15-16.594 27.103-17.892 26.958-1.298.145-24.697-11.959-18.082-26.958 6.622-10.067 16.052-4.606 18.078-1.364\"></path><defs><linearGradient id=\"a\" x1=\"20.692\" x2=\"42.638\" y1=\"50.067\" y2=\"16.543\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\" stop-opacity=\".4\"></stop><stop offset=\"1\" stop-color=\"#fff\"></stop></linearGradient></defs>", 3)
  ])))
}
export default { render: render }